export enum ProductCategory {
  CAJAS = 'Cajas',
  COMIDA_COCINADA = 'Comida cocinada',
  DESCATALOGADO = 'Descatalogado',
  IMPRESO = 'Impreso',
  MERCHANDISING = 'Merchandising',
  PLV = 'PLV',
  SNACK = 'Snack',
  SUPLEMENTO = 'Suplemento',
}

export interface ProductCategoryOption {
  value: ProductCategory;
  label: string;
}

export const productCategoryOptions: Array<ProductCategoryOption> = Object.values(
  ProductCategory
).map((category) => ({ value: category, label: category }));
